import React, { useEffect, useState } from "react";
import styled from 'styled-components';
import { Box } from "@mui/material";
import SidebarHeader from "../layout/SidebarHeader";
import CreateToken from "./CreateToken";
import TextButton from "components/TextButton";
import StacInterface from "utils/StacInterface";
import EditToken from "./EditToken";
import UpgradeModal from "components/UpgradeModal";

const Header = styled.div`
  margin: 0 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    font-size: 18px;
    line-height: 22px;
    color: #E5E5E5;
    font-weight: 400;
  }
`;

const Description = styled.p`
  font-family: Open Sans;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #A0A0A0;
  margin: 24px 0;
`;

const Contact = styled.div`
  background: #487BF2;
  border-radius: 3px;
  font-family: Open Sans;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #FFFFFF;
  padding: 17px 23px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  span {
    margin-right: 10px;
  }

  a {
    text-decoration: underline;
  }
`;

const TokenList = styled.div`
  h2 {
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    margin-bottom: 13px;
    color: #E5E5E5;
  }

  .header-box {
    border-top: 1px solid #a0a0a0;
    border-bottom: 1px solid #a0a0a0;

    .token-name {
      width: 35%;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
      color: #c4c4c4;
    }

    .token-endpoint {
      width: 15%;
      text-align: right;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
      color: #c4c4c4;
    }

    .token-status {
      width: 15%;
      text-align: right;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
      color: #c4c4c4;
    }

    .token-gb {
      width: 15%;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
      color: #c4c4c4;
      text-align: right;
    }

    .actions {
      width: 10%;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        font-size: 1.4rem !important;
      }
    }
  }

  .token-item {
    border-bottom: 1px solid #a0a0a0;
    .token-name {
      width: 35%;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
      color: #c4c4c4;
    }

    .token-endpoint {
      width: 15%;
      text-align: right;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
      color: #c4c4c4;
    }

    .token-status {
      width: 15%;
      text-align: center;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
      color: #c4c4c4;

      &.active {
        color: #15C67D; 
      }

      &.error {
        color: #DE5E56;
      }
    }

    .token-gb {
      width: 10%;
      font-weight: 400;
      font-size: 9px;
      line-height: 11px;
      color: #c4c4c4;
      text-align: right;
    }

    .actions {
      width: 10%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

var Circle = styled.div`
  width:6px;
  height:6px;
  border-radius:50%;
`;

const APIPage = ({ goToProfilePage }) => {
  const [isCreateable, setIsCreateable] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [tokens, setTokens] = useState([]);
  const [selectedToken, setSelectedToken] = useState();
  const [upgradeModalIsOpen, setUpgradeModalIsOpen] = useState(false);

  useEffect(() => {
    StacInterface.instance.getUserAPIKey().then((resp) => {
      if (resp.data) {
        setTokens([resp.data]);
      }
      if (resp.data == null) {
        setTokens([]);
      }
    }).catch((error) => {
      if (error.response.status === 403){
        setUpgradeModalIsOpen(true);
      }
    })
  }, [isCreateable, isEditable])

  const addToken = () => {
    if (tokens.length !== 0) return;
      setIsCreateable(true);
  };

  const handleTokenClicked = (token) => {
    setSelectedToken(token);
    setIsEditable(true);
  }

  return (
    <>
      <SidebarHeader onClose={goToProfilePage} />
      {
        !isCreateable && !isEditable ?
          <>
            <Header>
              <h2>API Keys</h2>
              <TextButton onClick={addToken} text="Generate API Key" />
            </Header>
            <Description>
              Generate a new API Key to authenticate and track use of FastMap Web Map Services.
            </Description>
            <TokenList>
              <h2>API Keys</h2>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                className="header-box"
                padding="7px"
              >
                <div className="token-name">NAME</div>
                <div className="token-endpoint">EXPIRY</div>
                <div className="token-status">STATUS</div>
              </Box>
              {tokens.map((token, index) => (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  className="token-item"
                  padding="7px"
                  key={index}
                  onClick={() => handleTokenClicked(token)}
                >
                  <div className="token-name">{token?.name}</div>
                  <div className="token-endpoint">{new Date(Date.parse(token?.expiration_datetime)).toLocaleDateString({ year: 'numeric', month: 'numeric', day: 'numeric' })}</div>
                  {token?.is_active ? <Circle style={{ backgroundColor: "green" }} /> : <Circle style={{ backgroundColor: "red" }} />}
                </Box>
              ))}
            </TokenList>
            {upgradeModalIsOpen && <UpgradeModal setIsOpen={setUpgradeModalIsOpen} templateName={'professional'} callOnClose={goToProfilePage}/>}
          </> :
          isCreateable ? <CreateToken tokens={tokens} setIsCreateable={setIsCreateable} /> :
            isEditable ? <EditToken setIsEditable={setIsEditable} token={selectedToken} /> : null
      }
    </>
  );
};

export default APIPage;
